module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-screen"
  }, [_c('router-link', {
    staticClass: "close",
    attrs: {
      "to": "../../"
    }
  }, [_c('span', {
    staticClass: "close__title"
  }, [_vm._v("Esc")])]), _vm._v(" "), _c('div', {
    staticClass: "add-pharmacy-wrapper"
  }, [_c('div', {
    staticClass: "pre-title"
  }, [_vm._v("Копирование стеллажа")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('select-material', {
    attrs: {
      "isMulti": false,
      "title": "Аптека",
      "possibleValues": _vm.pharmacies
    },
    on: {
      "select": function($event) {
        _vm.pharmacy = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "50px"
    }
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.copy()
      }
    }
  }, [_vm._v("Копировать")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35f0b236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pharmacy/CopyRack.vue
// module id = 239
// module chunks = 1